import { contentHeight } from "@/lib/element";
import { onUnmounted } from "vue";

export const AutoScroll = (el: any, binding: any) => {
  const observer = new MutationObserver((mutationRecords) => {
    mutationRecords.forEach(({ type, target }: any) => {
      if (type === "attributes" && target.classList.contains("item") && target.classList.contains("selected")) {
        const container = binding.value?.getBoundingClientRect() ?? null;
        if (container) {
          const ch = contentHeight(binding.value);
          const min = container.height - ch;

          const element = target.getBoundingClientRect();
          const top = element.top - container.top + element.height;

          if (top > container.height || top <= min) {
            target.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        }
      }
    });
  });

  observer.observe(el, {
    childList: true, // observe direct children
    subtree: true, // and lower descendants too
    attributes: true, // observe attributes
  });

  onUnmounted(() => {
    observer.disconnect();
  });
};
